import { render, staticRenderFns } from "./swGlobalLearningXprizeCoWinner.vue?vue&type=template&id=0d445932&scoped=true&"
import script from "./swGlobalLearningXprizeCoWinner.vue?vue&type=script&lang=js&"
export * from "./swGlobalLearningXprizeCoWinner.vue?vue&type=script&lang=js&"
import style0 from "./swGlobalLearningXprizeCoWinner.vue?vue&type=style&index=0&id=0d445932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d445932",
  null
  
)

export default component.exports